import {
  AxiosError,
  AxiosInterceptorManager,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

export const has401Interceptor = (
  manager: AxiosInterceptorManager<AxiosResponse>,
) =>
  manager.use(
    (res) => {
      if (res.config.withAuthorization === false)
        res.config.withCredentials = false;
      return res;
    },
    (err: AxiosError<InternalAxiosRequestConfig>) => {
      // Если запрос не требует авторизации, то не проверяем на 401
      if (err.config?.withAuthorization === false) return Promise.reject(err);
      // Проверяем, есть ли ответ с ошибкой
      if (err.response && err.response.status === 401) {
        // Сбросим данные от которых зависит редирект на /login или /
        localStorage.removeItem('USER_DATA');
        // Условие что находимся не на /login
        // чтобы избежать редиректа и сброса LoginForm при неверном вводе
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
          return Promise.reject(err);
        }
      }

      return Promise.reject(err);
    },
  );
